import { render, staticRenderFns } from "./sharedNode.vue?vue&type=template&id=f9a123d2&scoped=true"
import script from "./sharedNode.vue?vue&type=script&lang=js"
export * from "./sharedNode.vue?vue&type=script&lang=js"
import style0 from "./sharedNode.vue?vue&type=style&index=0&id=f9a123d2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a123d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9a123d2')) {
      api.createRecord('f9a123d2', component.options)
    } else {
      api.reload('f9a123d2', component.options)
    }
    module.hot.accept("./sharedNode.vue?vue&type=template&id=f9a123d2&scoped=true", function () {
      api.rerender('f9a123d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/questionnaireExamine/components/sharedNode.vue"
export default component.exports